import { stringify } from 'qs'

export const loginPath = args => {
  const path = '/login'

  if (args && args.query) {
    const query = stringify(args.query)
    return `${path}?${query}`
  }

  return path
}

export const logoutPath = () => '/logout'
export const signupPath = () => '/signup'
export const forgotPath = () => '/forgot'
export const enablePath = () => '/enable'
